import { render } from "./EventCard.vue?vue&type=template&id=48363b0c"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=48363b0c&lang=css"
script.render = render

export default script